import React from 'react';

import { useGetConnectedCfTokensQuery } from './api/cloudflareTokenApi';
import { useCloudflareBeta } from './useCloudflareBeta';

/**
 * Whether to offer the Cloudflare tokens tab (PRE-3360 / R9).
 *
 * The only evaluator of the rule: a screen that re-decides visibility itself is
 * a second copy that nothing keeps in step with this one.
 */
export const useCfTokensTabVisible = (): boolean => {
  const hasBetaAccess = useCloudflareBeta();
  const { data, isError } = useGetConnectedCfTokensQuery(undefined, { skip: hasBetaAccess });
  const wasOffered = React.useRef(false);

  // `isError` opens the tab on purpose: a failed read is no evidence of no token, and hiding
  // it would strand a token holder away from the only screen that disconnects it.
  if (hasBetaAccess || isError || (data?.total ?? 0) > 0) {
    wasOffered.current = true;
  }

  return wasOffered.current;
};
